<template>
  <el-dialog
    title="导出数据"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :show-close="false"
    :close-on-click-modal="false"
    width="50%"
    @close="$refs.form.resetFields(), $emit('input', false)"
  >
    <el-form ref="form" :model="form">
      <el-form-item label="部门" prop="department">
        <department-cascade v-model="form.department" placeholder="请选择部门"></department-cascade>
      </el-form-item>
      <el-form-item label="下载字段" prop="export">
        <el-checkbox-group v-model="form.export">
          <el-checkbox
            v-for="(item, index) in params"
            :key="index"
            :label="item.value"
            :disabled="['id', 'name'].includes(item.value)"
          >{{item.label}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
      <el-button @click="visible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DepartmentCascade from '@/components/service/department-cascade'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { DepartmentCascade },
  data () {
    return {
      loading: false,
      visible: false,
      params: [
        { label: '工号', value: 'id' },
        { label: '姓名', value: 'name' },
        { label: '邮箱', value: 'email' },
        { label: '地区', value: 'area' },
        { label: '入职时间', value: 'indate' },
        { label: '职位', value: 'zhiwei' },
        { label: '一级部门', value: 'first' },
        { label: '二级部门', value: 'second' },
        { label: '三级部门', value: 'third' },
        { label: '四级部门', value: 'fourth' },
        { label: '级别', value: 'level' },
        { label: '生日', value: 'birth' },
        { label: '手机', value: 'mobile' },
        { label: '学历', value: 'xueli' },
        { label: '学位', value: 'xuewei' },
        { label: '学校', value: 'xuexiao' },
        { label: '专业', value: 'zhuanye' },
        { label: '照片', value: 'photo' }
      ],
      form: {
        export: [ 'id', 'name' ],
        department: []
      }
    }
  },
  watch: {
    value (val) {
      this.visible = val
    }
  },
  methods: {
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          let params = JSON.parse(JSON.stringify(this.form))
          params.jiagou_first = this.form.department[ 0 ] || '-1'
          params.jiagou_second = this.form.department[ 1 ] || '-1'
          params.jiagou_third = this.form.department[ 2 ] || '-1'
          params.jiagou_forth = this.form.department[ 3 ] || '-1'
          delete params.department
          this.$http.post('/yuangong/down', params).then(res => {
            const $a = document.createElement('a')
            $a.href = res.data.url
            $a.click()
            this.visible = false
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
